import {gql} from "@apollo/client"
export const GET_TAG = gql`
  query GetTag($id: Int!) {
    GetTag(id: $id)
  }
`
